module.exports = __webpack_public_path__ + "img/sh.f82cca1c.png";